import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom';

import { BrandingContext } from './branding';
import App from './containers/App/App';
import './index.css';
import { imagesRoot } from './utils/imagesRoot';
import { isProd } from './utils/isProd';

if (isProd) {
  Sentry.init({
    dsn: 'https://9f0908f176d94780941b47b047461972@o1025844.ingest.sentry.io/4504684506185728',
    integrations: [ Sentry.browserTracingIntegration(), Sentry.replayIntegration() ],
    tracesSampleRate: 0.005,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

imagesRoot('/img');
ReactDOM.render(
  <React.StrictMode>
    <BrandingContext>
      <App />
    </BrandingContext>
  </React.StrictMode>,
  document.getElementById('root'),
);
